import React from 'react';
import { FieldProps } from 'formik';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';

import AvailabilitySelect from './AvailabilitySelect';

type Props = { card: CardHcd } & FieldProps;

const AvailabilityAppointment = ({ field, ...props }: Props) => (
  <AvailabilitySelect {...props} field={{ ...field }} />
);

export default AvailabilityAppointment;
